import api from "../../api/api";
import API_URL from "../../api/url";
import axios from 'axios';

const CustomerRequest = {

  customerList: (values) => api.get(`${API_URL.BASEURL}${API_URL.getCustomerList}`, {
    params: {
      gender: values?.gender,
      status: values?.status,
      name: values?.name,
      email: values?.email,
      page: values?.page,
      search: values?.search,
      limit: 10, 
    }
  }),
  transactionList: (userId) => api.get(`${API_URL.BASEURL}${API_URL.getTransactionList}?userId=${userId}`),
  customerDetail: (id) => api.post(`${API_URL.BASEURL}${API_URL.getCustomerDetails}`, id),
  // customerRatingDelete: (id) => api.post(`${API_URL.BASEURL}${API_URL.customerRatingDelete}`,id),
  deleteRating: (id) => api.post(`${API_URL.BASEURL}${API_URL.postDeleteRating}`, id),

  statusUpdate: (values) => api.post(`${API_URL.BASEURL}${API_URL.postRatingStatusUpdate}`, values),

  deleteCategory: (id) => api.post(`${API_URL.BASEURL}${API_URL.deleteCategory}`, id),
  customerStatusUpdate: (id) => api.post(`${API_URL.BASEURL}${API_URL.statusUpdate}`, id),
  updateCategory: (values) => api.post(`${API_URL.BASEURL}${API_URL.updateCategory}`, values),
  createCategory: (values) => api.post(`${API_URL.BASEURL}${API_URL.createCategory}`, values),
  uploadImage: (formData) => {
    const token = localStorage.getItem("accesstoken");


    return api.post(
      `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=category`,
      formData,
      {
        headers: {
          token: token ? `${token}` : "",
        },
      }
    );
  }


};



export default CustomerRequest